import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 6l9 0","key":"svg-0"}],["path",{"d":"M4 12l7 0","key":"svg-1"}],["path",{"d":"M4 18l7 0","key":"svg-2"}],["path",{"d":"M15 15l3 3l3 -3","key":"svg-3"}],["path",{"d":"M18 6l0 12","key":"svg-4"}]]

const IconSortDescending = createReactComponent('outline', 'sort-descending', 'SortDescending', __iconNode);

export default IconSortDescending;